import React, { useState, useRef, useEffect } from 'react';
import * as XLSX from 'xlsx';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Picture1, Footer_img } from '../../Constant/ImageConstant';
import './DownloadInvoice.css';
import { Api_Endpoints } from '../../Api/apiEndpoint';
import { makeApiCall } from '../../Api/makeApiCall';
import axios from 'axios';
import { getUserSession } from "../../utils/auth";
import { MdOutlineFileDownload } from "react-icons/md";
import { Loader2 } from "lucide-react";


const DownloadButton = ({ invoice, onDownload, isLoading }) => {
  return (
    <button 
      onClick={() => onDownload(invoice)} 
      className="download-pdf-icon"
      disabled={isLoading}
    >
      {isLoading ? (
        <Loader2 className="animate-spin" />
      ) : (
        <MdOutlineFileDownload />
      )}
    </button>
  );
};


const DownloadInvoice = () => {
  const user_data = getUserSession();
  console.log(user_data, 'usedata....')
  const [startDate, setStartDate] = useState('');
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [endDate, setEndDate] = useState('');
  const [invoiceNo, setInvoiceNo] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [allInvoices, setAllInvoices] = useState([]);
  const [currentInvoiceIndex, setCurrentInvoiceIndex] = useState(0);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const invoiceContainerRef = useRef(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isInvoiceVisible, setIsInvoiceVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [isLoading, setIsLoading] = useState(false);
const [downloadingInvoiceId, setDownloadingInvoiceId] = useState(null);
  const [currentInvoice, setCurrentInvoice] = useState({
    companyName: '',
    productName: '',
    invoiceNo: '',
    invoiceDate: '',
    invoicePeriod: '',
    invoiceAmount: '',
    hsnCode: '',
    gstRate: '',
    gstAmount: '',
    totalAmount: '',
    amountInWords: ''
  });
  useEffect(() => {
    const token = localStorage.getItem('vendorManagement');
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);
  
  useEffect(() => {
    if (allInvoices.length > 0 && currentInvoiceIndex < allInvoices.length) {
      setCurrentInvoice(allInvoices[currentInvoiceIndex]);
    }
  }, [currentInvoiceIndex, allInvoices]);

  
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    
    if (file) {
      try {
        const user_data = getUserSession();
        if (!user_data?.token) {
          alert('Please login to upload the file');
          return;
        }
  
        // Create FormData object
        const formData = new FormData();
        formData.append('file', file);
  
        // Make API call
        const response = await axios({
          method: 'POST',
          url: Api_Endpoints.INVOICE_EXPORT_EXCEL_FILE,
          data: formData,
          headers: {
            'Authorization': `Bearer ${user_data.token}`,
            'Content-Type': 'multipart/form-data'
          },
          timeout: 30000
        });
  
        // Log the response to see its structure
        console.log('API Response:', response.data);
  
        // Check if response.data exists and handle different response formats
        if (response.data) {
          let invoices = [];
  
          // Handle different possible response formats
          if (Array.isArray(response.data)) {
            // If response.data is already an array
            invoices = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            // If response.data has a data property that's an array
            invoices = response.data.data;
          } else if (typeof response.data === 'object') {
            // If response.data is a single object
            invoices = [response.data];
          } else {
            throw new Error('Invalid response format');
          }
  
          // Map the invoices to ensure consistent structure
          const formattedInvoices = invoices.map(item => ({
            companyName: item.companyName || item.company_name || '',
            productName: item.productName || item.product_name || '',
            invoiceNo: item.invoiceNo || item.invoice_no || '',
            invoiceDate: item.invoiceDate || item.invoice_date || '',
            invoicePeriod: item.invoicePeriod || item.invoice_period || '',
            invoiceAmount: item.invoiceAmount || item.invoice_amount || '',
            hsnCode: item.hsnCode || item.hsn_code || '',
            gstRate: item.gstRate || item.gst_rate || '',
            gstAmount: item.gstAmount || item.gst_amount || '',
            totalAmount: item.totalAmount || item.total_amount || '',
            amountInWords: item.amountInWords || item.amount_in_words || ''
          }));
  
          // Update state with the formatted invoices
          setAllInvoices(formattedInvoices);
          setCurrentInvoiceIndex(0);
          if (formattedInvoices.length > 0) {
            setCurrentInvoice(formattedInvoices[0]);
          }
          alert(`Successfully imported ${formattedInvoices.length} invoices`);
        } else {
          throw new Error('No data received from server');
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        
        if (axios.isAxiosError(error)) {
          // Log detailed error information
          console.error('Axios Error Details:', {
            response: error.response?.data,
            status: error.response?.status,
            headers: error.response?.headers
          });
  
          switch (error.response?.status) {
            case 401:
              alert('Your session has expired. Please login again.');
              localStorage.removeItem('vendorManagement');
              break;
            case 403:
              alert('You do not have permission to upload files.');
              break;
            case 413:
              alert('File size too large. Please upload a smaller file.');
              break;
            case 415:
              alert('Invalid file format. Please upload an Excel file.');
              break;
            case 500:
              alert('Server error. Please try again later.');
              break;
            default:
              alert(`Error uploading file: ${error.response?.data?.message || 'Please try again.'}`);
          }
        } else if (error.message === 'Network Error') {
          alert('Network error. Please check your connection and try again.');
        } else {
          alert(`Error uploading file: ${error.message}`);
        }
        
        // Reset file input
        setSelectedFile(null);
        const fileInput = document.getElementById('csvFile');
        if (fileInput) {
          fileInput.value = '';
        }
      }
    }
  };

  const fetchInvoices = async (page = 1) => {
    setIsLoading(true);
    setError(null);
  
    try {
      const user_data = getUserSession();
      if (!user_data?.token) {
        throw new Error('Please login to view invoices');
      }
  
      const response = await axios({
        method: 'POST',
        url: `${Api_Endpoints.INVOICE_SHOW_INVOICE}?page=${page}`,
        headers: {
          'Authorization': `Bearer ${user_data.token}`,
          'Content-Type': 'application/json'
        }
      });
  
      const { data } = response.data.result;
      console.log(data, '87987987987987')
      // Set pagination data
      setCurrentPage(data.invoice_details.current_page);
      setTotalPages(data.invoice_details.last_page);
  
      // Map API data to table structure
      const formattedInvoices = data.invoice_details.data.map(invoice => ({
        id: invoice.id,
        company_name: invoice.company_name,
        product: invoice.product,
        invoice_number: invoice.invoice_number,
        invoice_date: invoice.invoice_date,
        invoice_period: invoice.invoice_period,
        amount: invoice.amount?.toLocaleString(),
        hsn_code: invoice.hsn_code || 'N/A',
        rate: invoice.rate,
        gst: invoice.gst?.toLocaleString(),
        total: invoice.total?.toLocaleString(),
        status: 'Pending' // You can add status logic here
      }));
  
      setInvoices(formattedInvoices);
  
    } catch (error) {
      console.error('Error fetching invoices:', error);
      setError(error.message || 'Error fetching invoices');
      
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        localStorage.removeItem('vendorManagement');
      }
    } finally {
      setIsLoading(false);
    }
  };
  const Pagination = () => (
    <div className="pagination">
      <button 
        onClick={() => fetchInvoices(currentPage - 1)}
        disabled={currentPage === 1 || isLoading}
        className="pagination-button"
      >
        Previous
      </button>
      
      <span className="pagination-info">
        Page {currentPage} of {totalPages}
      </span>
      
      <button 
        onClick={() => fetchInvoices(currentPage + 1)}
        disabled={currentPage === totalPages || isLoading}
        className="pagination-button"
      >
        Next
      </button>
    </div>
  );
  useEffect(() => {
    fetchInvoices(1); // Fetch first page when component mounts
  }, [])

  const handleImportCSV = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const workbook = XLSX.read(e.target.result, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const headers = data[0].map(h => h.trim());
        console.log('Headers:', headers);
        const invoices = data.slice(1)
          .filter(row => row.length >= headers.length && row[0])
          .map(row => {
            const invoice = {
            
            
            
            companyName: row[0] || '',
            productName: row[1] || '',
            invoiceNo: row[2] || '',
            invoiceDate: row[3] || '',
            invoicePeriod: row[4] || '',
            invoiceAmount: row[5] || '',
            hsnCode: row[6] || '',
            gstRate: row[7] || '',
            gstAmount: row[8] || '',
            totalAmount: row[9] || '',
            amountInWords: row[10] || ''
          };
          console.log('Mapped invoice:', invoice); // Debug log
          return invoice;
        });

        setAllInvoices(invoices);
        console.log('All invoices:', invoices);
        setCurrentInvoiceIndex(0);
        if (invoices.length > 0) {
          setCurrentInvoice(invoices[0]);
        }
        alert(`Successfully imported ${invoices.length} invoices`);
      } catch (error) {
        console.error('Error importing file:', error);
        alert('Error importing file. Please check the format and try again.');
      }
    };
    reader.readAsBinaryString(file);
  };

  

  const handleDownloadExcelSample = async () => {
    try {
      console.log('Starting Excel download...');
      
      // Get and validate token
      let token =user_data.token;
      try {
        token = token;
      } catch (error) {
        alert('Please login to download the file');
        // Optionally redirect to login page
        return;
      }
      
      // Add token validation check
      if (typeof token !== 'string' || token.trim() === '') {
        alert('Invalid authentication token. Please login again.');
        setIsLoggedIn(false);
        localStorage.removeItem('vendorManagement');
        return;
      }

      const response = await axios({
        url: Api_Endpoints.INVOICE_DOWNLOAD,
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Content-Type': 'application/json'
        },
        // Add timeout and retry logic
        timeout: 30000, // 30 seconds
        validateStatus: status => status === 200
      });

      // Validate response
      if (!response.data || !(response.data instanceof Blob)) {
        throw new Error('Invalid response format');
      }

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      // Validate blob
      if (blob.size === 0) {
        throw new Error('Empty file received');
      }

      // Create and trigger download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'invoice_sample.xlsx');
      
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
      
      console.log('Download completed successfully');
      
    } catch (error) {
      console.error('Error downloading Excel file:', error);
      
      if (axios.isAxiosError(error)) {
        switch (error.response?.status) {
          case 401:
            alert('Your session has expired. Please login again.');
            setIsLoggedIn(false);
            localStorage.removeItem('vendorManagement');
            // Optionally redirect to login page
            break;
          case 403:
            alert('You do not have permission to download this file.');
            break;
          case 404:
            alert('File not found on the server.');
            break;
          case 500:
            alert('Server error. Please try again later.');
            break;
          default:
            alert('Error downloading file. Please try again.');
        }
      } else if (error.message === 'Network Error') {
        alert('Network error. Please check your connection and try again.');
      } else {
        alert(`Error downloading file: ${error.message}`);
      }
    }
  };

  const handleFileDownload = (blob) => {
    if (blob.size === 0) {
      throw new Error('Empty file received');
    }
  
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'invoice_sample.xlsx';
    
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
  };
  
  const handleDownloadInvoice = async (invoice) => {
    try {
      setDownloadingInvoiceId(invoice.id);
      const user_data = getUserSession();
      if (!user_data?.token) {
        throw new Error('Please login to download invoice');
      }
  
      const response = await fetch(`${Api_Endpoints.INVOICE_PDF_GENERATE}/${invoice.id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${user_data.token}`,
          // 'Accept': 'application/pdf'
          'Accept': '*/*',
          'Content-Type': 'multipart/form-data;'
        }
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      // Get the PDF data as an array buffer
      const pdfData = await response.arrayBuffer();
      
      // Convert array buffer to blob with proper PDF MIME type
      const blob = new Blob([pdfData], { type: 'application/pdf' });
      
      // Create temporary URL for the blob
      const url = window.URL.createObjectURL(blob);
      
      // Create temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.download = `invoice-${invoice.invoice_number || 'download'}.pdf`;
      
      // Append link to body, trigger download, and clean up
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Release the blob URL
      window.URL.revokeObjectURL(url);
  
    } catch (error) {
      console.error('Error downloading invoice:', error);
      
      if (error.response?.status === 401) {
        alert('Your session has expired. Please login again.');
        localStorage.removeItem('vendorManagement');
      } else if (error.message.includes('NetworkError')) {
        alert('Network error. Please check your connection and try again.');
      } else {
        alert(`Error downloading invoice: ${error.message}`);
      }
    } finally {
      // Clear loading state
      setDownloadingInvoiceId(null);
    };
  };


  
  
  const styles = `
.download-pdf-icon {
  background: none;
  border: none;
  cursor: pointer;
  color: #2196F3;
  font-size: 1.5rem;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.download-pdf-icon:hover {
  color: #1976D2;
  background-color: rgba(33, 150, 243, 0.1);
}

.download-pdf-icon:active {
  transform: scale(0.95);
}
`;
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  // Filter invoices based on search criteria
  const filteredInvoices = invoices.filter(invoice => {
    const matchesInvoiceNo = !invoiceNo || 
      invoice.invoiceNo.toLowerCase().includes(invoiceNo.toLowerCase());
    
    const matchesDateRange = (!startDate || !endDate) || 
      (new Date(invoice.invoiceDate) >= new Date(startDate) && 
       new Date(invoice.invoiceDate) <= new Date(endDate));

    return matchesInvoiceNo && matchesDateRange;
  });

  return (
    <>
      <div className="page-container">
      <h1 className="page-title">GENERATE INVOICE</h1>

      <div className="file-section-download-invoice">
        <div className="file-input-group">
          <input
            type="file"
            id="csvFile"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          <label htmlFor="csvFile" className="file-choose-btn">
            Choose File
          </label>
          <span className="file-name">
            {selectedFile ? selectedFile.name : 'No file chosen'}
          </span>
        </div>
        
        <div className="sample-file-link">
          <button>
          <a href="#" onClick={handleDownloadExcelSample}>
            Download Excel Sample File
          </a>
          </button>
        </div>
      </div>

      <div className="filters-section">
        <div className="date-filters">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="date-input"
            placeholder="Start Date"
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="date-input"
            placeholder="End Date"
          />
        </div>

        <div className="search-section">
          <input
            type="text"
            value={invoiceNo}
            onChange={(e) => setInvoiceNo(e.target.value)}
            placeholder="Search Invoice No..."
            className="invoice-search"
          />
        </div>
      </div>
      <div className="table-container">
    {isLoading ? (
      <div>Loading...</div>
    ) : error ? (
      <div>Error: {error}</div>
    ) : (
      <>
        <table className="invoice-tables">
          <thead>
            <tr>
              <th>Company Name</th>
              <th>Product</th>
              <th>Invoice No</th>
              <th>Invoice Date</th>
              <th>Invoice Period</th>
              <th>Invoice Amount</th>
              <th>HSN/SAC</th>
              <th>Rate</th>
              <th>GST Amount</th>
              <th>Total Amount</th>
              {/* <th>Status</th> */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice, index) => (
              console.log(invoice, '68687687668'),
              <tr key={`${invoice.id}-${index}`}>
                <td>{invoice.company_name}</td>
                <td>{invoice.product}</td>
                <td>{invoice.invoice_number}</td>
                <td>{invoice.invoice_date}</td>
                <td>{invoice.invoice_period}</td>
                <td>{invoice.amount}</td>
                <td>{invoice.hsnCode}</td>
                <td>{invoice.rate}%</td>
                <td>{invoice.gst}</td>
                <td>{invoice.total}</td>
                {/* <td>{invoice.status}</td> */}
                <td>
                      <DownloadButton 
                        invoice={invoice}
                        onDownload={handleDownloadInvoice}
                        isLoading={downloadingInvoiceId === invoice.id}
                      />
                    </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination />
      </>
    )}
      </div>
        

      </div>

     
    </>
  );
}

export default DownloadInvoice;